// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1ht3M","cell":"ColumnAccessor_cell__2KB5j","firstCellAccent":"ColumnAccessor_firstCellAccent__2bhy1"};